import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const DEFAULT_META = {
    total: 0,
    page: 1,
    limit: 50,
    totalPages: 1,
};

const getBorderData = createAsyncThunk(
    "api/employees",
    async (
        { token, page = 1, limit = 50, finance } = {},
        { rejectWithValue }
    ) => {
        try {
            const response = await nodeinstance.get("/employees", {
                headers: { Authorization: `Bearer ${token}` },
                params: { page, limit, finance },
            });
            return {
                data: response?.data?.data || [],
                meta: response?.data?.meta || { ...DEFAULT_META, page, limit },
            };
        } catch (e) {
            return rejectWithValue(e?.response?.data?.message || e.message);
        }
    }
);


const BorderDataSlice = createSlice({
    name: "boder",
    initialState: {
        data: null,
        meta: DEFAULT_META,
        error: "",
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getBorderData.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.meta = action.payload.meta || DEFAULT_META;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getBorderData.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getBorderData.rejected, (state, action) => {
                state.isLoading = false;
                state.status = false;
                state.error = action.payload || action.error.message;
            });
    },
});

export { getBorderData };
export default BorderDataSlice.reducer;
